import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

export default function SortBar({
  sortBy,
  setSortBy,
  selectedLeadStatus,
  setSelectedLeadStatus,
  selectedManualChange,
  setSelectedManualChange,
  leadStatusFilterDisabled,
}) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" },
        gap: 1.5,
      }}
    >
      <FormControl fullWidth size="small">
        <InputLabel>Sort By</InputLabel>
        <Select
          value={sortBy}
          label="Sort By"
          onChange={(e) => setSortBy(e.target.value)}
        >
          <MenuItem value="">None</MenuItem>
          <MenuItem value="name-asc">Name (A to Z)</MenuItem>
          <MenuItem value="name-desc">Name (Z to A)</MenuItem>
          <MenuItem value="rank-asc">Crunchbase Rank (Low to High)</MenuItem>
          <MenuItem value="rank-desc">Crunchbase Rank (High to Low)</MenuItem>
          <MenuItem value="employees-desc">Employees (High to Low)</MenuItem>
          <MenuItem value="employees-asc">Employees (Low to High)</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth size="small">
        <InputLabel>Lead Status</InputLabel>
        <Select
          disabled={leadStatusFilterDisabled}
          value={selectedLeadStatus}
          label="Lead Status"
          onChange={(e) => setSelectedLeadStatus(e.target.value)}
        >
          <MenuItem value="">All Statuses</MenuItem>
          <MenuItem value="ACCEPT">Leads</MenuItem>
          <MenuItem value="NOT ACCEPT">Discard</MenuItem>
          <MenuItem value="FUZZY">Unsure</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth size="small" sx={{ gridColumn: { md: "1 / -1" } }}>
        <InputLabel>Manual Change</InputLabel>
        <Select
          value={selectedManualChange}
          label="Manual Change"
          onChange={(e) => setSelectedManualChange(e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="manual-only">Manual Changes Only</MenuItem>
          <MenuItem value="no-manual">No Manual Changes</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
